/* Built In Imports */
/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
/* Styles */
import styles from '@lb/Sections/aboutDevi/styles.module.css';
/* Services */

const AboutDeviSlide16 = () => {
  return (
    <Box
      bgColor="#000"
      className={styles.section16Bg}
      background={`#000 url(${config.imgPath}/d/46272/1684475602-ib_secion16bg.jpg) no-repeat center top`}
      bgSize={{ base: '70rem', lg: 'cover' }}
    >
      <Box
        maxW="1300px"
        mx="auto"
        display="flex"
        position="relative"
        alignItems="center"
        justifyContent="center"
        minH="100vh"
      >
        <Box
          maxW="500px"
          w="100%"
          textAlign="center"
          px={{ base: '16px', md: '10px' }}
          py="180px"
        >
          <Heading
            color="common.white"
            fontSize={{ base: '64px', lg: '100px' }}
            lineHeight={{ base: '60px', lg: '104px' }}
            fontFamily="'FedraSerifDisplay'"
            pb={4}
          >
            Linga Bhairavi
          </Heading>
          <Text color="secondary.main" fontSize={{ base: '18px', lg: '24px' }}>
            is depicted as the dark one because she resides in emptiness, where
            even light does not exist. From this emptiness, she brings to life
            all creation.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide16;
